import React, { Component } from 'react'
import './EventTracker.css'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class EventReviewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reviewReason: '',
      selectedFile: null,
      uploadedFilePath: null,
      isUploading: false,
      uploadError: null,
      error: null
    }
    this.fileInputRef = React.createRef();
  }

  handleReasonChange = (e) => {
    this.setState({ reviewReason: e.target.value })
  }

  handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      this.setState({ 
        selectedFile: file, 
        uploadedFilePath: null,
        uploadError: null
      });
      this.uploadFile(file);
    }
  }
  
  uploadFile = (file) => {
    this.setState({ isUploading: true, uploadError: null });
    
    // Get user ID from event or use a default
    const userId = (this.props.event.tracker.user && this.props.event.tracker.user.userId) ? this.props.event.tracker.user.userId : '1';
    const fileName = file.name;
    
    // First get a signed URL from the API
    RestApiUtils.get(
      this.props.context,
      `/api/s3/fileUploadSignedUrl/${userId}/${fileName}`,
      this.handleSignedUrlResponse,
      this.handleUploadError
  )
  }
  
  handleSignedUrlResponse = (response) => {
    if (response && response.success === 'success' && response.signedUrl) {
      const { signedUrl, path } = response;
      // Store the path and upload the file
      this.setState({ uploadedFilePath: path });
      this.uploadFileToS3(signedUrl, path);
    } else {
      this.setState({ 
        isUploading: false, 
        uploadError: 'Failed to get upload URL' 
      });
    }
  }
  
  uploadFileToS3 = (signedUrl, path) => {
    const { selectedFile } = this.state;
    if (!selectedFile) {
      this.setState({ isUploading: false });
      return;
    }
    
    // Upload directly using fetch
    fetch(signedUrl, {
      method: 'put',
      body: selectedFile,
    })
      .then(response => {
        console.log('S3 upload response:', response.status);
        if (response.ok) {
          this.setState({ 
            isUploading: false,
            uploadError: null
          });
        } else {
          throw new Error('Upload failed: ' + response.status);
        }
      })
      .catch(error => {
        console.error('Upload error:', error);
        this.setState({ 
          isUploading: false, 
          uploadError: 'Failed to upload file',
          uploadedFilePath: null
        });
      });
  }
  
  handleUploadError = (error) => {
    console.error('Upload error:', error);
    this.setState({ 
      isUploading: false, 
      uploadError: typeof error === 'string' ? error : 'Failed to upload file',
      uploadedFilePath: null
    });
  }

  handleSubmit = () => {
    const { reviewReason, uploadedFilePath, isUploading } = this.state
    const { event, reviewStatus, onSubmit } = this.props

    // Don't submit while a file is uploading
    if (isUploading) {
      this.setState({ error: 'Please wait for file upload to complete.' })
      return
    }
    
    if (!reviewReason) {
      this.setState({ error: 'Please provide a reason for your decision.' })
      return
    }

    // Call parent submit handler with review data
    onSubmit({
      trackerId: event.tracker.trackerId,
      reviewStatus: reviewStatus,
      reviewReason: reviewReason,
      filePath: uploadedFilePath || null
    })
  }

  render() {
    const { event, reviewStatus, onClose, context } = this.props
    const { 
      reviewReason, 
      error, 
      selectedFile, 
      isUploading, 
      uploadError, 
      uploadedFilePath 
    } = this.state

    console.log('Event:', event)

    return (
      <div className="event-review-modal-overlay">
        <div className="event-review-modal">
          <div className="event-review-modal-header">
            <div className="event-review-modal-title">
              <span className="event-name">{event.tracker.event.eventName}</span>
              <span className="event-id">ID: {event.tracker.trackerId}</span>
            </div>
            {/* <IconButtonUI icon="close" onClick={onClose} /> */}
          </div>
          
          <div className="event-review-modal-body">
            <h3>{reviewStatus === 'APPROVE' ? 'Approve' : 'Reject'} Event</h3>
            
            <div className="form-group">
              <label htmlFor="reviewReason">Reason {reviewStatus === 'APPROVE' ? 'for approval' : 'for rejection'}</label>
              <textarea 
                id="reviewReason" 
                className="review-reason-input"
                value={reviewReason}
                onChange={this.handleReasonChange}
                placeholder={`Enter your reason for ${reviewStatus === 'APPROVE' ? 'approving' : 'rejecting'} this event...`}
                rows={4}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="fileUpload">Attachment (optional)</label>
              <div className="file-upload-container">
                <input 
                  type="file"
                  id="fileUpload"
                  className="file-upload-input"
                  onChange={this.handleFileChange}
                  accept="*"
                  disabled={isUploading}
                  ref={this.fileInputRef}
                />
                <div 
                  className={`file-upload-button ${isUploading ? 'disabled' : ''}`} 
                  onClick={!isUploading ? () => this.fileInputRef.current && this.fileInputRef.current.click() : undefined}
                >
                  <IconButtonUI icon="icon-paperclip" disabled={isUploading} />
                  <span>Choose File</span>
                </div>
                
                {selectedFile && (
                  <div className="file-name">
                    {isUploading ? (
                      <span className="file-uploading">Uploading {selectedFile.name}...</span>
                    ) : uploadedFilePath ? (
                      <span className="file-uploaded">
                        <IconButtonUI icon="icon-check" /> {selectedFile.name}
                      </span>
                    ) : (
                      <span>{selectedFile.name}</span>
                    )}
                  </div>
                )}
                
                {!selectedFile && !isUploading && (
                  <div className="file-name">No file chosen</div>
                )}
              </div>
              
              {uploadError && (
                <div className="upload-error">{uploadError}</div>
              )}
            </div>
            
            {error && <div className="error-message">{error}</div>}
          </div>
          
          <div className="event-review-modal-footer">
            <button className="cancel-button" onClick={onClose}>Cancel</button>
            <button 
              className={`submit-button ${reviewStatus === 'APPROVE' ? 'approve' : 'reject'}`}
              onClick={this.handleSubmit}
            >
              {reviewStatus === 'APPROVE' ? 'Approve' : 'Reject'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default EventReviewModal
